import {Component, Input} from '@angular/core';
import {GlobalSearchResult} from '../../../dtos/search/global-search-result';

@Component({
  selector: 'app-search-result-item',
  templateUrl: './search-result-item.component.html',
  styleUrl: './search-result-item.component.scss',
  standalone: false
})
export class SearchResultItemComponent {
  @Input() result: GlobalSearchResult;
}
